export default __webpack_public_path__ + "static/media/icons8-people.1e043969.svg";